export const Permissions = {
  APPROVE_ACCOUNTS: "APPROVE_ACCOUNTS",
  CHARGE_CREDIT_CARD: "CHARGE_CREDIT_CARD",
  CREATE_CREDIT_CARD: "CREATE_CREDIT_CARD",
  CREATE_DEACTIVATEREQUEST: "CREATE_DEACTIVATEREQUEST",
  CREATE_ORGANIZATION: "CREATE_ORGANIZATION",
  CREATE_WORK: "CREATE_WORK",
  CREATE_USER: "CREATE_USER",
  DEACTIVATE_USERS_FROM_MY_ORGANIZATION:
    "DEACTIVATE_USERS_FROM_MY_ORGANIZATION",
  DELETE_CREDIT_CARD: "DELETE_CREDIT_CARD",
  DELETE_ORGANIZATION: "DELETE_ORGANIZATION",
  DELETE_WORK: "DELETE_WORK",
  DOWNLOAD_TRANSACTION_INFORMATION: "DOWNLOAD_TRANSACTION_INFORMATION",
  EDIT_LICENSE_TYPES: "EDIT_LICENSE_TYPES",
  REQUEST_DEACTIVATION: "REQUEST_DEACTIVATION",
  MANAGE_ADHOC_AGREEMENTS: "MANAGE_ADHOC_AGREEMENTS",
  MANAGE_ALL_LICENSE_REQUESTS: "MANAGE_ALL_LICENSE_REQUESTS",
  MANAGE_ALL_ORGANIZATIONS: "MANAGE_ALL_ORGANIZATIONS",
  MANAGE_MY_CART: "MANAGE_MY_CART",
  SIGN_LICENSE_REQUEST_CONTRACTS: "SIGN_LICENSE_REQUEST_CONTRACTS",
  UPLOAD_SPREADSHEET_WITH_NEW_SONGS: "UPLOAD_SPREADSHEET_WITH_NEW_SONGS",
  UPDATE_ALL_CUSTOMER_USER: "UPDATE_ALL_CUSTOMER_USER",
  UPDATE_ALL_DEACTIVATEREQUEST: "UPDATE_ALL_DEACTIVATEREQUEST",
  UPDATE_ALL_LICENSEREQUEST: "UPDATE_ALL_LICENSEREQUEST",
  UPDATE_ALL_ORGANIZATION: "UPDATE_ALL_ORGANIZATION",
  UPDATE_ALL_USER: "UPDATE_ALL_USER",
  UPDATE_MY_CREDIT_CARD: "UPDATE_MY_CREDIT_CARD",
  UPDATE_MY_ORGANIZATION: "UPDATE_MY_ORGANIZATION",
  UPDATE_MY_PROJECTS: "UPDATE_MY_PROJECTS",
  UPDATE_MY_ORGANIZATION_USERS: "UPDATE_MY_ORGANIZATION_USERS",
  UPDATE_WORK: "UPDATE_WORK",
  VIEW_ALL_USERS_WITH_LICENSE_REQUESTS: "VIEW_ALL_USERS_WITH_LICENSE_REQUESTS",
  VIEW_ALL_CUSTOMER_USER: "VIEW_ALL_CUSTOMER_USER",
  VIEW_ALL_DEACTIVATEREQUEST: "VIEW_ALL_DEACTIVATEREQUEST",
  VIEW_ALL_LICENSEREQUEST: "VIEW_ALL_LICENSEREQUEST",
  VIEW_ALL_LICENSETYPE: "VIEW_ALL_LICENSETYPE",
  VIEW_ALL_PROJECTS: "VIEW_ALL_PROJECTS",
  VIEW_ALL_INTERNAL_USER: "VIEW_ALL_INTERNAL_USER",
  VIEW_ALL_ORGANIZATION: "VIEW_ALL_ORGANIZATION",
  VIEW_MY_CREDIT_CARD: "VIEW_MY_CREDIT_CARD",
  VIEW_MY_LICENSE_REQUESTS: "VIEW_MY_LICENSE_REQUESTS",
  VIEW_MY_ORGANIZATION: "VIEW_MY_ORGANIZATION",
  VIEW_MY_ORGANIZATION_USERS: "VIEW_MY_ORGANIZATION_USERS",
};
